import ApiService from "@/core/services/api.service";

export default {
  select(query = {}) {
    return ApiService.query('client/orders', query);
  },
  find(id) {
    return ApiService.query(`client/orders/${id}`);
  },
  create(data = {}) {
    return ApiService.post('client/orders', data);
  },
  update(id, data = {}) {
    return ApiService.patch(`client/orders/${id}`, data);
  },
  delete(id) {
    return ApiService.delete(`client/orders/${id}`);
  }
};
